import { AccountPartialUpdatePostData, CustomerId } from './Types';

import { genericJsonFetchWithoutResponseData } from '../Util';

export function updateAccountPartial(
    data: AccountPartialUpdatePostData,
    onSuccess: () => void,
    profileId?: CustomerId,
    onError?: (json: any) => void,
    onFailure?: (error: Error) => void,
) {
    if (!data) {
        return;
    }

    const profilePath = profileId ? `/${profileId}` : '';

    genericJsonFetchWithoutResponseData(
        `/api/account/partial${profilePath}`,
        onSuccess,
        'Could not save account properties',
        'Server failure while saving account properties: %o',
        { method: 'put', body: JSON.stringify(data) },
        onError,
        onFailure,
    );
}
